<template>
  <div class="app-container">
    <div class="tip01">
      {{ $t('placeOrder.automaticPrinting1') }}
      <el-link :href="$store.getters.expressWmsPluginLink" style="font-size: 16px" type="warning">
        {{ $t('placeOrder.automaticPrinting2') }}
      </el-link>
      {{ $t('placeOrder.automaticPrinting3') }}
    </div>
    <el-form
      ref="ruleFormRef"
      :inline="true"
      :model="queryForm"
      label-position="top"
      size="large"
      @submit.native.prevent
    >
      <el-form-item prop="number">
        <span>{{ $t('orderCenterCont.ExchangeOrders') }}</span>
        <span>+</span>
        <span style="margin-right: 10px">{{ $t('scripting.consolidation') }}</span>
        <el-select v-model="scanType" style="width: 150px; margin-top: 10px; margin-right: 5px">
          <el-option :label="$t('GlobalSetObj.scannerNumber')" :value="1" />
          <el-option :label="$t('newOrder.InvoiceKey')" :value="2" />
        </el-select>
        <el-input
          ref="inputRef"
          v-model.trim="queryForm.number"
          clearable
          style="width: 400px"
          @keyup.enter.native="scannerFun"
        />
      </el-form-item>
      <!--      <el-form-item prop="">-->
      <!--        <div style="margin-top: 10px">-->
      <!--          <el-button type="primary" @click="getSearch">{{ $t('newOrder.search') }}</el-button>&lt;!&ndash; 搜索 &ndash;&gt;-->
      <!--          <el-button type="info" @click="reset">{{ $t('newOrder.reset') }}</el-button>-->
      <!--        </div>-->
      <!--      </el-form-item>-->
    </el-form>
    <el-row :gutter="20">
      <el-col :span="24" style="border-top: 1px solid #cccccc; margin-top: -10px">
        <div style="padding: 7px 0">
          <span>{{ $t('GlobalSetObj.package') }}:</span>
          <span style="color: #f9a025; font-weight: bold">{{ tableDataLeftAll.length }}</span>
          <span style="margin-left: 20px">{{ $t('mdfeTranslate.TotalWeight') }}:</span>
          <span style="color: #f9a025; font-weight: bold"> {{ weightTotal }}KG</span>
        </div>
      </el-col>
      <el-col :span="14">
        <!--  表格数据  -->
        <el-table
          :data="tableDataLeft"
          :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
          border
          height="600"
          style="width: 100%"
        >
          <el-table-column
            :label="$t('collectionCenter.scanInfo')"
            align="center"
            min-width="180"
            prop="number"
          />
          <el-table-column
            :label="$t('orderCenterCont.anjunWaybillNumber')"
            align="center"
            min-width="160"
            prop="waybillNumber"
          >
            <template #default="scope">
              <div>{{ scope.row.waybillNumber || '--' }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('collectionCenter.printTime')"
            align="center"
            min-width="180"
            prop="scanTime"
          />
          <el-table-column
            :label="$t('trailer.weight')"
            align="center"
            min-width="150"
            prop="weight"
          />
        </el-table>
        <!--  分页  -->
        <el-pagination
          :current-page="queryForm.pageNumber"
          :page-size="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="queryForm.total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0; float: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-col>
      <el-col :span="10">
        <div class="flex-start" style="margin-bottom: 10px">
          <div>{{ $t('GlobalSetObj.bagNumber') }}</div>
          <el-input
            v-model.trim="inputBagNumber"
            :placeholder="$t('GlobalSetObj.pleaseInput')"
            style="width: 300px"
          />
          <el-button :disabled="isDisable" type="success" @click="SealingBag">{{ $t('GlobalSetObj.envelope') }}
          </el-button>
        </div>
        <!--  表格数据  -->
        <el-table
          :data="tableDataRight"
          :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
          border
          height="600"
          style="width: 100%"
        >
          <el-table-column
            :label="$t('collectionCenter.BagNumber')"
            align="center"
            prop="transitBagNumber"
            width="100"
          >
            <template #default="scope">
              <span style="cursor: pointer" @click="GET_SEAL_RECORD_DETAIL(scope.row)">
                {{ scope.row.transitBagNumber }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('collectionCenter.numberPackages')"
            align="center"
            min-width="180"
            prop="packageCount"
          />
          <el-table-column
            :label="$t('GlobalSetObj.totalWeightKG')"
            align="center"
            min-width="160"
            prop="totalWeight"
          >
            <template #default="scope">
              <div>{{ scope.row.totalWeight }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('collectionCenter.sealingBagTime')"
            align="center"
            min-width="180"
            prop="createTime"
          />
        </el-table>
      </el-col>
    </el-row>
    <!-- 打印面单  -->
    <div style="display: none">
      <pdf ref="pdfPrint" :src="viewUrl" />
    </div>
    <!-- 隐藏提示音 -->
    <div v-show="false">
      <audio ref="errRef" :src="errorMp3" controls="controls" />
      <audio ref="okRef" :src="okMp3" controls="controls" />
    </div>
    <printTipsCom ref="printTipsComRef" @autoPrint="printFun" />
  </div>
</template>

<script>
import {
  orderChangeCollectBag,
  parcelConfirmat,
  pcScanSealABagNumber,
  queryBagNumberRecord,
  querySealBagInfo,
  sealBag
} from '@/api/automaticSorting';
import pdf from 'vue-pdf-messy-code-fix';
import { apiStartUp, autoPrint } from '@/api/serialPort';
import printTipsCom from './component/printTipsCom.vue';

const okMp3 = 'https://anjunggl-1313947203.cos.ap-guangzhou.myqcloud.com/app/static/music/su.wav';
const errorMp3 =
  'https://anjunggl-1313947203.cos.ap-guangzhou.myqcloud.com/app/static/music/print_error.wav';
export default {
  name: 'QuickOrderChange',
  components: {
    pdf,
    printTipsCom
  },
  data() {
    return {
      timeValue: [],
      scanType: 1,
      checkList: '',
      printTipsVisible: false,
      viewUrl: '',
      // 是否格式化成巴西时间
      isTormat: false,
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        number: '',
        beginPrintDate: '',
        endPrintDate: ''
      },
      tableDataLeft: [],
      tableDataRight: [],
      okMp3,
      errorMp3,
      weightTotal: 0,
      resultData: [],
      inputBagNumber: '',
      // 新增：缓存用的全量数据
      tableDataLeftAll: [],
      isDisable: false
    };
  },
  activated() {
    this.$nextTick((_) => {
      this.$refs.inputRef.$refs.input.focus();
    });
  },
  mounted() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.$nextTick((_) => {
      this.$refs.inputRef.$refs.input.focus();
    });
    // 页面加载时从 localStorage 恢复数据
    const cachedData = localStorage.getItem('tableDataLeftAll');
    if (cachedData) {
      try {
        this.tableDataLeftAll = JSON.parse(cachedData);
        // 触发前端分页
        this.getSearch();
      } catch (e) {
        this.tableDataLeftAll = [];
      }
    }
    this.GET_SEAL_RECORD();
  },
  methods: {
    // 点击封袋
    async SealingBag() {
      if (this.inputBagNumber) {
        const res = await pcScanSealABagNumber({
          transitBagNumber: this.inputBagNumber
        });
        if (res.code === 200) {
          console.log('pcScanSealABagNumber');
          const data = {
            bagNumber: this.inputBagNumber,
            weight: this.weightTotal,
            numberList: []
          };
          if (this.tableDataLeftAll.length > 0) {
            this.tableDataLeftAll.forEach((item) => {
              const obj = {
                collectOrderId: item.collectOrderId,
                waybillNumber: item.waybillNumber
              };
              data.numberList.push(obj);
            });
            try {
              const result = await sealBag(data);
              this.inputBagNumber = '';
              this.reset();
              await this.GET_SEAL_RECORD();
              console.log(result, 'sealBag');
            } catch (e) {
              console.log(e);
            }
          }
        }
      } else {
        this.$message.error(this.$t('GlobalSetObj.PleaseBagNumber'));
        this.$refs.errRef.play();
      }
    },
    // 查询封袋记录
    async GET_SEAL_RECORD() {
      const res = await queryBagNumberRecord();
      if (res.code === 200) {
        this.tableDataRight = res.data || [];
      }
    },
    // 查询封袋详情
    async GET_SEAL_RECORD_DETAIL(row) {
      const data = row.transitBagNumber;
      return;
      const res = await querySealBagInfo(data);
      if (res.code === 200) {
        if (res.data && res.data.length > 0) {
          this.isDisable = true;
        } else {
          this.isDisable = false;
        }
        // ✅ 替换全量数据
        this.tableDataLeftAll = res.data || [];
        // ✅ 保存到 localStorage
        this.saveToCache();
        // ✅ 重新分页
        this.getSearch();
      }
    },
    // 保存到 localStorage
    saveToCache(val) {
      try {
        if (val === 1) {
          this.submitFun();
        }
        localStorage.setItem('tableDataLeftAll', JSON.stringify(this.tableDataLeftAll));
      } catch (e) {
        console.error('localStorage 存储失败', e);
      }
    },
    reset() {
      // 清空输入框
      this.queryForm.number = '';
      this.queryForm.pageNumber = 1;
      this.isDisable = false;
      // ✅ 清空全量数据
      this.tableDataLeftAll = [];
      // ✅ 清除缓存
      localStorage.removeItem('tableDataLeftAll');
      // 重新分页
      this.getSearch();
    },
    // 查询（前端分页）
    getSearch() {
      const { pageNumber, pageSize } = this.queryForm;
      const allData = this.tableDataLeftAll;
      // 设置总数
      this.queryForm.total = allData.length;
      // 按 scanTime 倒序排序(最新的在前面)
      const sortedData = [...allData].sort((a, b) => {
        return new Date(b.scanTime) - new Date(a.scanTime);
      });
      // 计算分页起始位置
      const start = (pageNumber - 1) * pageSize;
      const end = start + pageSize;
      // 截取当前页数据
      this.tableDataLeft = sortedData.slice(start, end);
      // 重新计算当前页总重量(只算当前页的)
      this.calcTotalWeight();
    },
    // 扫描
    scannerFun() {
      if (this.queryForm.number) {
        // 当处于 查看袋号明细的情况 下扫描
        if (this.isDisable) {
          this.queryForm.pageNumber = 1;
          this.isDisable = false;
          // ✅ 清空全量数据
          this.tableDataLeftAll = [];
          // ✅ 清除缓存
          localStorage.removeItem('tableDataLeftAll');
          // 重新分页
          this.getSearch();
        }
        const data = {
          scanType: this.scanType,
          number: this.queryForm.number
        };
        // 先判断：输入框的值是否已经存在于列表中
        const isInputExist = this.tableDataLeftAll.some((item) => {
          const itemNo = item.number || item;
          return itemNo === this.queryForm.number.trim();
        });
        // 如果已经存在，直接提示并返回，不调用接口
        if (isInputExist) {
          this.$message.warning(this.$t('GlobalSetObj.notrepeatOperation'));
          // return;
        }
        orderChangeCollectBag(data).then((res) => {
          if (res.code === 200 && res.data) {
            // 关键：拿到数组
            this.resultData = res.data.numberList || [];
            if (this.scanType === 1) {
              // 检测到重复, 只选择打印, 不走其他的地方
              if (!isInputExist) {
                // ✅ 添加到全量数据
                this.tableDataLeftAll.push(...this.resultData);
                // ✅ 保存到 localStorage
                this.saveToCache();
                // ✅ 重新执行前端分页
                this.getSearch();
              }
              this.printFun();
            } else {
              // 检测到重复, 只选择打印, 不走其他的地方
              if (!isInputExist) {
                // 多条时弹窗让用户选择打印哪些
                if (res.data.numberList && res.data.numberList.length > 1) {
                  this.$refs.printTipsComRef.showTip(this.resultData);
                } else {
                  console.log(this.resultData, '单条直接打印');
                  this.tableDataLeftAll.push(...this.resultData);
                  // 单条直接打印
                  this.printFun();
                }
                // ✅ 扫描发票号：先弹窗确认，数据也要加入缓存
                this.saveToCache();
                this.getSearch();
              }
            }
          }
        });
      }
    },
    submitFun() {
      const data = {
        numberList: []
      };
      this.resultData.forEach((item) => {
        const obj = {
          waybillNumber: item.waybillNumber
        };
        data.numberList.push(obj);
      });
      parcelConfirmat(data).then((res) => {
        if (res.code === 200) {
          console.log(res);
        }
      });
    },
    // 触发打印接口
    // 触发打印接口（修复版：严格按顺序一张一张打印）
    async printFun(arg) {
      console.log(arg, 'printFun', this.resultData);
      if (arg === 1) {
        this.tableDataLeftAll.push(...this.resultData);
        // ✅ 扫描发票号：先弹窗确认，数据也要加入缓存
        this.saveToCache();
        this.getSearch();
      }
      // ✅ 打开 Loading
      const loading = this.$loading({
        lock: true,
        text: this.$t('scripting.consolidation'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.submitFun();
      try {
        // 1. 调用启动接口
        const res1 = await apiStartUp();
        if (res1.code !== 200) {
          this.$refs.errRef.play();
          this.$message.error(this.$t('GlobalSetObj.setDefaultPrinter'));
          this.$nextTick(() => {
            this.$refs.inputRef.$refs.input.select();
          });
          return;
        }

        // 你的打印数据（保留原样）
        const printDataList = this.resultData;

        // ✅ 核心修复：循环 + await → 严格按顺序一张一张打印
        for (const item of printDataList) {
          try {
            const resPrint = await autoPrint(item.labelUrl);

            if (resPrint.code === 200) {
              await this.$refs.okRef.play();
            } else {
              throw new Error(this.$t('scripting.printFailed'));
            }
          } catch (err) {
            await this.$refs.errRef.play();
            this.$message.error(this.$t('GlobalSetObj.PrintFailure'));
            // 一张失败，不影响后续继续打印（你要中断的话，这里加 return）
          }
        }
        // ✅ 所有面单全部打印完成后执行
        this.$message.success(this.$t('collectionCenter.printSuc'));
        this.queryForm.number = '';
        this.$nextTick(() => {
          this.$refs.inputRef.$refs.input.focus();
        });
        this.getSearch();
        this.printTipsVisible = false;
      } catch (e) {
        console.log(e, 'printFun异常');
        this.$refs.errRef.play();
        this.$message.error(this.$t('GlobalSetObj.setDefaultPrinter'));
        this.$nextTick(() => {
          this.$refs.inputRef.$refs.input.select();
        });
      } finally {
        // ✅ 无论成功、失败、异常，最终都会关闭 Loading
        loading.close();
      }
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    // 专门计算总重量的方法（复用）
    calcTotalWeight() {
      const total = this.tableDataLeftAll.reduce((sum, item) => {
        return sum + parseFloat(item.weight || 0);
      }, 0);
      // 保留 3 位小数
      this.weightTotal = total.toFixed(3);
    }
  }
};
</script>

<style scoped>
.textClass >>> ::v-deep .el-textarea__inner {
  max-height: 200px;
}

.dialog-footer {
  text-align: center;
}

.dialog-footer >>> .el-button:first-child {
  margin-right: 20px;
}

.printTips_class {
  padding-top: 10px;
  padding-left: 40px;
  box-sizing: border-box;
}

.printTips_title {
  margin-bottom: 10px;
}

.printTips_class >>> .el-radio-group .el-radio {
  display: block !important;
  margin-bottom: 5px;
}

.app-container >>> .el-dialog__body {
  padding: 10px 20px;
}

.tip01 {
  background-color: #ecf5ff;
  color: #409eff;
  padding: 10px;
  font-size: 14px;
  border-radius: 5px;
}
</style>
